import React from "react";
import { Link } from "react-router-dom";

// services
import { UserService } from "app/_services/UserService/UserService";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";

class ViewUserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: {},
    };
  }

  componentDidMount() {
    this.loggedUser();
  }

  async loggedUser() {
    let response = await UserService.loggedUser();
    if (response && response.status) {
      this.setState({
        userData: response.data,
      });
    }
  }

  render() {
    const {
      firstName,
      lastName,
      email,
      classification,
      comapnyId,
      displayName,
      employeeId,
      functionName,
      siteName,
      supervisorName,
      joiningDate,
      landlineNumber,
      emergencyContact,
      officeAddress,
      siteAddress,
      remarks,
      contactNumber,
      role,
      department,
      document,
      signature,
      dob,
    } = this.state.userData;
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[{ name: "User Profile", path: "#" }]}
          breadCrumbsText="Profile_icon_view_profile"
        />
        <div className="row d-flex justify-content-center">
          <div className="col-md-7">
            <div className="card mt-4 mb-3">
              <div className="card-body">
                <form className="p-3 pb-0">
                  <div className="row align-items-center pb-4">
                    <div className="col-md-3 text-center">
                      <div className="profile-imgbx">
                        {document && document.document_name ? (
                          <img
                            className="img-thumbnail"
                            src={URL_CONFIG.IMG_URL + document.document_name}
                            alt="profile"
                          />
                        ) : (
                          <img src="/assets/images/userImage.jpg" alt="profile" />
                        )}
                      </div>
                    </div>
                    <div className="col-md-9 userInfoDetails">
                      <h2>{firstName ? firstName + " " + (lastName ? lastName : "") : ""}</h2>
                      <p className="textLight">
                        <span>E-mail: </span>
                        {email}
                      </p>
                      <p className="textLight">
                        <span>Phone: </span>
                        {contactNumber}
                      </p>
                      <div class="mt-3">
                        {/* <a class="btn btn-primary" href="/profile">Edit My Profile</a> */}
                        <Link to="/profile" className="btn btn-primary">
                          Edit My Profile
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="userInfo_otherDetails">
                    <div className="row">
                      <div className="col-md-6 userInfo_cols">
                        <strong>User Type:</strong>
                        <label>{classification}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Access Type:</strong>
                        <label>{role && role.title}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Organisation Name</strong>
                        <label>{comapnyId}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Display Name:</strong>
                        <label>{displayName}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Employee Id:</strong>
                        <label>{employeeId}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Department Name:</strong>
                        <label>{department && department.name}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Function Name:</strong>
                        <label>{functionName}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Plant/Site Name:</strong>
                        <label>{siteName}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Supervisor Name:</strong>
                        <label>{supervisorName}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Date of Joining:</strong>
                        <label>{formatDDMMYYYYbyYYYYMMDD(joiningDate)}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Landline number:</strong>
                        <label>{landlineNumber}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Office Address:</strong>
                        <label>{officeAddress}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Site Address:</strong>
                        <label>{siteAddress}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Emergency Contact:</strong>
                        <label>{emergencyContact}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Remarks:</strong>
                        <label>{remarks}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Date of Birth:</strong>
                        <label>{formatDDMMYYYYbyYYYYMMDD(dob)}</label>
                      </div>
                      <div className="col-md-6 userInfo_cols">
                        <strong>Signature:</strong>
                        <div>
                          {signature?.document_name && (
                            <img
                              className="img-thumbnail"
                              src={URL_CONFIG.IMG_URL + signature.document_name}
                              alt="signature"
                              width={150}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ViewUserProfile;
